import {isValidEmail, makeValidation} from '@eitje/form'

export const validateEmail = makeValidation(isValidEmail, 'form.general.validation.email')
